import { render, staticRenderFns } from "./Detail-Consumption.vue?vue&type=template&id=37ad6491"
import script from "./Detail-Consumption.vue?vue&type=script&lang=js"
export * from "./Detail-Consumption.vue?vue&type=script&lang=js"
import style0 from "./Detail-Consumption.vue?vue&type=style&index=0&id=37ad6491&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports